import cn from 'clsx'

import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import InlineSVG from 'svg-inline-react'
type Item = Record<string, any>
type Props = {
  active?: boolean
  children?: React.ReactNode
  className?: string
  tabIndex?: number
  items: Item[]
}
export default class TabNav extends Component<Props> {
  static defaultProps: {
    active: boolean
    className: string
  } = {
    active: false,
    className: '',
  }

  render(): React.ReactElement<'div'> | React.ReactElement<'nav'> {
    const { className, items } = this.props
    // TODO: Modifier class needs refactoring to avoid this suboptimal wrap
    return className ? (
      <div className={className}>
        <nav className="Tab_Nav">{items.map(this._renderItems)}</nav>
      </div>
    ) : (
      <nav className="Tab_Nav">{items.map(this._renderItems)}</nav>
    )
  }

  _renderItems: (
    arg0: Item,
    index: number,
  ) => React.ReactNode | React.ReactElement<'label'> = (
    {
      active,
      className,
      label,
      link,
      icon,
      alias,
      disabled,
      hidden,
      onClick,
      ...rest
    }: Item,
    index: number,
  ) => {
    const rootClass = cn(
      'Tab_Label',
      {
        Tab_Active: active,
        Tab_Hidden: hidden,
        Tab_Disabled: disabled,
      },
      className,
    )
    return link ? (
      <Link
        to={link}
        key={index}
        {...rest}
        className={rootClass}
        onClick={!disabled ? onClick : null}
      >
        {icon && (
          <InlineSVG
            className="Tab_Icon"
            src={require(`!svg-inline!assets/icons/${icon}.svg`)}
          />
        )}
        {label}
      </Link>
    ) : (
      <label
        key={index}
        {...rest}
        className={rootClass}
        onClick={!disabled ? onClick : null}
      >
        {icon && (
          <InlineSVG
            className="Tab_Icon"
            src={require(`!svg-inline!assets/icons/${icon}.svg`)}
          />
        )}
        {label}
      </label>
    )
  }
}
